import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { isAuthenticated } from './storage';
import RegistrationPage from './pages/RegistrationPage';
import LoginPage from './pages/LoginPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import LogActivityPage from './pages/LogActivityPage';
import ActivityDetailsPage from './pages/ActivityDetailsPage';
import FriendsPage from './pages/FriendsPage';
import ChallengesPage from './pages/ChallengesPage';
import ChallengeDetailPage from './pages/ChallengeDetailPage';
import AchievementsPage from './pages/AchievementsPage';
import SpudMarketPage from './pages/SpudMarketPage';
import NotificationsPage from './pages/NotificationsPage';
import UserProfilePage from './pages/UserProfilePage';
import HotPotatoSendPage from './pages/HotPotatoSendPage';
import HotPotatoViewPage from './pages/HotPotatoViewPage';
import HotPotatoHistoryPage from './pages/HotPotatoHistoryPage';
import BottomNav from './components/BottomNav';

// Auth handling (auto-logout on 401) lives in the shared API client (api/client.js).

function PrivateRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated() ? (
                    <div className="app-layout">
                        <div className="app-content">
                            <Component {...props} />
                        </div>
                        <BottomNav />
                    </div>
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
}

function App() {
    return (
        <Router>
            <Switch>
                <Route path="/register" component={RegistrationPage} />
                <Route path="/login" component={LoginPage} />
                <Route path="/verify" component={VerifyEmailPage} />
                <PrivateRoute path="/dashboard" component={DashboardPage} />
                <PrivateRoute path="/profile" component={ProfilePage} />
                <PrivateRoute path="/log-activity" component={LogActivityPage} />
                <PrivateRoute path="/friends" component={FriendsPage} />
                <PrivateRoute path="/challenges/:challengeId" component={ChallengeDetailPage} />
                <PrivateRoute path="/challenges" component={ChallengesPage} />
                <PrivateRoute path="/achievements" component={AchievementsPage} />
                <PrivateRoute path="/spudmarket" component={SpudMarketPage} />
                <PrivateRoute path="/notifications" component={NotificationsPage} />
                <PrivateRoute path="/activity/:activityId" component={ActivityDetailsPage} />
                <PrivateRoute path="/user/:username" component={UserProfilePage} />
                <PrivateRoute path="/hot-potato/send" component={HotPotatoSendPage} />
                <PrivateRoute path="/hot-potato/:hotPotatoId" component={HotPotatoViewPage} />
                <PrivateRoute path="/hot-potato" component={HotPotatoHistoryPage} />
                <Redirect exact from="/" to="/login" />
            </Switch>
        </Router>
    );
}

export default App;